module.exports = __webpack_public_path__ + "img/whereareamillion.71d422c2.jpg";